import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as React from "react"
import * as Common from "./common"
import { Row, DicoChapter } from "./table-definition"
import Popup from "../../ppi/ppi-detail/utils/popup"

export default class ChapterHeader extends React.Component<Props, State> {
	constructor(props: Readonly<Props>) {
		super(props)
		this.state = { edit: false, value: props.row.amount,submitting:false }
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (this.props.row.chapter.number !== nextProps.row.chapter.number) {
			return true
		}

		if (this.state.edit !== nextState.edit) {
			return true
		}

		return true;
	}

	render() {
		const editable = false !== this.props.row.editableHeader
		return <div
		className="scenario-chapter-header"
		title={this.props.row.title}>
			<span className="scenario-header-identifier">
				{this.props.row.chapter.number}
			</span>

			<span className="scenario-header-title">{this.props.row.title}</span>

			{this.renderBadge(editable)}
			{this.renderEditButton(editable)}
			{this.renderTogglerButton()}
			{this.renderPopup()}
		</div>
	}

	private handleClickEdit(): void {
		this.setState({ edit: true })
	}

	private handleClickToggler(): void {
		this.props.onToggleChapter(this.props.row.chapter)
	}

	private handleDelete(e): void {
		e.preventDefault()
		this.setState({ submitting: true })
		this.props.onChange("chapter", {
			chapter: this.props.row.chapter,
			amount: null
		})
		this.setState({ submitting: true },()=>{
			setTimeout(() => {
				this.setState({ edit: false,submitting:false })
			}, 1500)
		})
	}

	private handleHidePopup(): void {
		this.setState({ edit: false })
	}

	private handleInputChange(e: React.ChangeEvent<HTMLInputElement>): void {
		const value = NaN !== e.target.valueAsNumber ? e.target.valueAsNumber : null
		this.setState({ value })
	}

	private handleSubmit(e: React.FormEvent<HTMLFormElement>): void {
		e.preventDefault()
		this.props.onChange("chapter", {
			chapter: this.props.row.chapter,
			amount: this.state.value
		})
		this.setState({ submitting: true },()=>{
			setTimeout(() => {
				this.setState({ edit: false,submitting:false })
			}, 1500)
		})
	}

	private renderBadge(editable: boolean): React.ReactNode {
		if (editable && null != this.props.row.amount)
			return <span className="scenario-percentile">
				{this.props.row.amount}%
			</span>
	}

	private renderDeleteButton(): React.ReactNode {
		if (null != this.props.row.amount)
			return <button
			className={`button is-secondary ${this.state.submitting?"is-loading":""}`}
			onClick={(e) => this.handleDelete(e)}>
				Supprimer la valeur
			</button>
	}

	private renderEditButton(editable: boolean): React.ReactNode {
		if (editable && this.props.row.chapter.id >= 0)
			return <button onClick={() => this.handleClickEdit()}>
				<FontAwesomeIcon icon="edit"/>
			</button>
	}

	private renderPopup(): React.ReactNode {
		if (this.state.edit)
			return <Popup
			onHide={() => this.handleHidePopup()}
			title="Pourcentage pour le chapitre">
				<div className="edit-box-content">
					<span className="scenario-popup-description">
						Vous allez modifier les pourcentages appliqués à l'ensemble du chapitre
					</span>

					<strong>{this.props.row.chapter.label}</strong>

					<form onSubmit={e => this.handleSubmit(e)}>
						<div className="columns is-desktop">
							<div className="column">
								<p className="field is-horizontal">
									<span className="field-label is-normal">
										<label className="label" htmlFor="amount">
											Pourcentage
										</label>
									</span>
									<span className="field-body">
										<span className="field">
											<span className="control">
												<input
												className="input"
												name="amount"
												required
												step="0.01"
												type="number"
												value={this.state.value}
												onChange={e => this.handleInputChange(e)}/>
											</span>
										</span>
									</span>
								</p>
							</div>
						</div>

						<button className={`button is-primary ${this.state.submitting?"is-loading":""}`}>Enregistrer</button>

						{this.renderDeleteButton()}
					</form>
				</div>
			</Popup>
	}

	private renderTogglerButton(): React.ReactNode {
		const icon: IconProp = this.props.row.isShown
		? "chevron-up"
		: "chevron-down"

		return <button onClick={() => this.handleClickToggler()}>
			<FontAwesomeIcon icon={icon}/>
		</button>
	}
}

interface Props {
	row: Row;
	onChange(type: "chapter", data: Common.ChapterChangeData): void;
	onToggleChapter(chapter: DicoChapter): void;
}

interface State {
	edit: boolean;
	value: number;
	submitting:boolean
}



// WEBPACK FOOTER //
// ./src/component/scenarii/detail/chapter-header.tsx